.group {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  flex: none;
}

.boxed {
  padding: 2px;
  background: var(--c-surface-sunken);
  border: 1px solid var(--c-border);
  border-radius: 9px;
}

.option {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 26px;
  min-width: 30px;
  padding: 0 10px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--c-text-tertiary);
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.md .option {
  height: 30px;
  padding: 0 12px;
  border-radius: var(--radius-sm);
  font-size: var(--text-caption);
}

.chips .option {
  height: 28px;
  border-radius: var(--radius-sm);
}

.md.chips .option {
  height: 30px;
}

.option:hover:not(:disabled):not(.selected) {
  background: var(--c-overlay);
  color: var(--c-text-primary);
}

.selected {
  background: var(--c-brand-subtle);
  color: var(--c-brand-muted);
  font-weight: 600;
}

/* A signed choice — long or short — takes the direction pill's colours when selected, so the
   selector reads like the label the saved strategy will carry and an unmade choice is obvious. */
.selected_pos {
  background: var(--c-positive-subtle);
  color: var(--c-positive);
}

.selected_neg {
  background: var(--c-negative-subtle);
  color: var(--c-negative);
}

.option:disabled,
.locked {
  color: var(--c-text-disabled);
}

.mono {
  font-family: var(--font-mono);
}

/* The count in the corner: how many conditions live on this timeframe (web_app_design.md §4). */
.badge {
  position: absolute;
  top: -5px;
  right: -4px;
  min-width: 14px;
  height: 14px;
  padding: 0 3px;
  border-radius: 7px;
  background: var(--c-brand);
  color: var(--c-on-brand, #fff);
  font-family: var(--font-mono);
  font-size: 9px;
  font-weight: 600;
  line-height: 14px;
  text-align: center;
  pointer-events: none;
}

.selected .badge {
  background: var(--c-brand-muted);
}
